import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal } from '@investoro/core';
import styled from 'styled-components';

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 50px;
    padding: 60px;
    color: var(--color-var);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    border-radius: var(--box-border-radius);


    @media (max-width: 600px) {
        padding: 80px 20px;
    }
  
`;

const Field = styled.div`
    display: flex;
    gap: 50px;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 600px) {        
        flex-direction: column;
        gap:20px;
        align-items: center;
        justify-content: flex-start;
    }
`;

interface Props {
    isOpen: boolean;
    availableResource: { smsCount: number | null, tokenCount: number | null };
    onClose: () => void;
}

const ResourcePopup: FC<Props> = ({ isOpen, availableResource, onClose }) => {
    const navigate = useNavigate();
    if (!isOpen) return null;

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => onClose()}
            centeredContent
            strictContentHeight
            overflowing
        >
            <ModalContent>
                {availableResource.smsCount !== null && availableResource.smsCount <= 10 && <Field>

                    <h1>Dostępna liczba SMSów: {availableResource.smsCount}</h1>
                    <Button onClick={() => {
                        navigate('/purchase/sms', {
                            state: { quantity: 100 }
                        });
                        localStorage.setItem('smsInfoShown', 'false');
                        onClose();
                    }}>
                        Dokup smsy
                    </Button>
                </Field>}

                {availableResource.tokenCount !== null && availableResource.tokenCount <= 50000 && <Field>

                    <h1>Dostępna liczba tokenów: {availableResource.tokenCount}</h1>
                    <Button onClick={() => {
                        navigate('/purchase/tokens', {
                            state: { quantity: 100000 }
                        });
                        localStorage.setItem('tokenInfoShown', 'false');
                        onClose();
                    }}>
                        Dokup tokeny
                    </Button>
                </Field>}

            </ModalContent>
        </Modal>
    );
};

export default ResourcePopup;
